import React from 'react';
import Icon from '@pushpay/icon';
import { createUseStyles } from '@pushpay/styles';
const directionAngles = {
  left: '0deg',
  up: '90deg',
  right: '180deg',
  down: '-90deg'
};
const useStyles = createUseStyles({
  root: ({
    direction
  }) => ({
    transform: `rotate(${directionAngles[direction]})`
  })
});

const ArrowIcon = ({
  direction = 'left',
  ...props
}) => {
  const classes = useStyles(undefined, {
    direction
  });
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    className: classes.root,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 10.8H6.53a.21.21 0 01-.138-.366L13.61 4.08a1.204 1.204 0 00-1.588-1.808l-9.343 8.226a2.007 2.007 0 000 3.01l9.341 8.225a1.203 1.203 0 001.588-1.807L6.39 13.572a.21.21 0 01.138-.366h14.3a1.204 1.204 0 000-2.407v.001z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default ArrowIcon;